import { useTranslation } from "react-i18next";
import { NotificationType } from "../../../../store/notification/notification-slice";
import { useRootSelector } from "store/hooks";

import classes from "./NotificationMsg.module.scss";

export interface NotificationMsgProps {
  type?: NotificationType;
  messages?: string[];
  translatedMessages?: string[];
  isClosable?: boolean;
  isDismissing?: boolean;
  isSlideoutBanner?: boolean;
  onClose: () => void;
}

export const NotificationMsg: React.FC<NotificationMsgProps> = ({
  type,
  messages,
  translatedMessages,
  isClosable = true,
  isDismissing = false,
  isSlideoutBanner = true,
  onClose,
}) => {
  const { t } = useTranslation(["common"]);
  const { isSlideOpen } = useRootSelector((state) => state.common);

  const printMessage = (single: string, i: number) => {
    // This check is a temporary fix and should be changed
    // when we look at and rework notifications.
    // The reason for this is because 'common:' often shows
    // in the error message if we do not return a translation key.
    const hasNamespaceAfterTranslation =
      t(`common:${single}`).substring(0, 7) === "common:";

    return (
      <p
        key={i}
        className={[
          classes.Messages,
          isSlideoutBanner && isSlideOpen ? classes.SlideMessage : "",
          isClosable ? classes.AlignMessage : classes.MatrixMessage,
        ].join(" ")}
      >
        {single === "invalid_identifier_number" ? (
          t(`common:${single}`, {
            email: client.primaryContactPhone,
            phone: client.primaryContactEmail,
          })
        ) : single === "INVALID_BUSEY_ROUTING_NUMBER" ? (
          <span
            dangerouslySetInnerHTML={{
              __html: t(`common:${single}`, {
                link: '<a href="https://www.busey.com/">here</a>',
              }),
            }}
          />
        ) : hasNamespaceAfterTranslation ? (
          single
        ) : (
          t(`common:${single}`)
        )}
      </p>
    );
  };

  const printTranslatedMessage = (translatedMessage: string, i: number) => {
    return (
      <p
        key={i}
        className={[
          classes.Messages,
          isSlideoutBanner && isSlideOpen ? classes.SlideMessage : "",
          isClosable ? classes.AlignMessage : classes.MatrixMessage,
        ].join(" ")}
      >
        {translatedMessage}
      </p>
    );
  };

  const renderMessages = () => {
    // Translated messages take precedence over messages (which are just a translation key in the common space)
    if (translatedMessages) {
      return translatedMessages.map(printTranslatedMessage);
    }
    if (messages) {
      return messages.map(printMessage);
    }
  };

  const wrapperClass = [classes.Default];
  if (type === "ERROR") {
    wrapperClass.push(classes.Error);
  } else if (type === "SUCCESS") {
    wrapperClass.push(classes.Success);
  }
  const { client } = useRootSelector((state) => state.config);

  const handleNotificationClose = () => {
    onClose();
  };

  return (
    <div
      role="alert"
      className={`${wrapperClass.join(" ")} ${isDismissing ? "fade" : ""}`}
    >
      {renderMessages()}
      {isClosable && (
        <ft-button
          class={[classes.Dissmiss, "outline-button"].join(" ")}
          outlined
          onClick={handleNotificationClose}
          label={t("common:dismiss_label")}
        ></ft-button>
      )}
    </div>
  );
};
